export default () => {
  if (process.env.NODE_ENV !== 'production') return
  if (window.__gaLoaded) return

  const loadGA = () => {
    if (window.__gaLoaded) return
    window.__gaLoaded = true

    const s = document.createElement('script')
    s.src = 'https://www.googletagmanager.com/gtag/js?id=G-QCP89CMGBX'
    s.async = true
    document.body.appendChild(s)

    window.dataLayer = window.dataLayer || []

    window.gtag = function () {
      window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())
    window.gtag('config', 'G-QCP89CMGBX', {
      send_page_view: true
    })
  }

  // 1️⃣ tenta carregar quando o browser estiver ocioso
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadGA, { timeout: 3000 })
  }

  // 2️⃣ fallback garantido (não falha nunca)
  setTimeout(loadGA, 3000)

  // 3️⃣ fallback por interação
  window.addEventListener('scroll', loadGA, { once: true })
  window.addEventListener('click', loadGA, { once: true })
}
